export function imageExists(image) {
  return image && image.localFile && image.localFile.childImageSharp && (image.localFile.childImageSharp.fluid || image.localFile.childImageSharp.fixed);
}